var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('picture',[(_vm.hasWebp)?_c('source',{ref:"source",attrs:{"srcset":_vm.webp,"type":"image/webp"}}):_vm._e(),_c('img',{ref:"img",class:_vm.className,attrs:{"src":_vm.defaultUrl,"loading":"lazy","title":_vm.title,"alt":_vm.alt},on:{"click":function($event){return _vm.$emit('click')},"error":_vm.errorHandler}})])
}
var staticRenderFns = []

export { render, staticRenderFns }